import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import moment from "moment";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import "./permission"; 
import * as echarts from "echarts";
import component from '@/components/common'

import i18n from "./lang/i18n";
// use添加i18n
Vue.use( {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(component);
Vue.use(Antd);
Vue.prototype.$echarts = echarts;



Vue.prototype.$moment = moment;

Vue.config.productionTip = false

Vue.prototype.$eb = new Vue();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
